<template>
  <div class="main">
    <el-row :gutter="20">
      <el-col :span="6">
        <draggable
          :list="list"
          :disabled="!enabled"
          class="list-group"
          v-bind="dragOptions"
          @start="dragging = true"
          @end="dragging = false"
        >
        <transition-group type="transition" name="flip-list">
          <div
            class="list-group-item"
            v-for="(element, idx) in list"
            :key="element.id"
          >
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span> Lição </span>
                <el-button style="float: right;" icon="el-icon-menu"></el-button>
                <el-button style="float: right;" icon="el-icon-delete" @click="removeAt(idx)"></el-button>
              </div>
              <div>
                <el-col :span="18" class="card-item list-group-item">
                  <div class="card-item-content">
                    <label> Titulo da Lição: </label>
                    <el-input v-model="element.title"></el-input>
                  </div>
                  <div class="card-item-content">
                    <label> Lição: </label>
                    <el-input
                      type="textarea"
                      v-model="element.name"
                    ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <label> Tipo da Lição: </label>
                  <el-select v-model="value" placeholder="Select">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </div>
            </el-card>
          </div>
          </transition-group>
        </draggable>
      </el-col>
    </el-row>
    <el-button icon="el-icon-plus" @click="add()"></el-button>
    <rawDisplayer class="col-3" :value="list" title="List" />
  </div>
</template>

<script>
import draggable from 'vuedraggable';
let id = 1;
export default {
  components: {
    draggable,
    
  },
  data() {
    return {
      enabled: true,
      list: [
        { title: '12121', name: '1212', id },
        { title: 'teste', name: '12121', id: id++ },
        ],
      dragging: false,
      tipoLicao: 'textarea',
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    add: function() {
      console.log('aqui');
      this.list.push({ id: id++, title: '', name: ''});
    },
    removeAt(idx) {
      this.list.splice(idx, 1);
    },
    checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
  },
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.list-group {
  width: 70vw;
  flex-direction: column;
  justify-content: space-between;
}
.list-group-item {
  margin-top: 20px;
}
.el-card {
  padding: 20px;
}
.card-item-content {
  padding: 10px;
}
.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
